import { render, staticRenderFns } from "./OtherPurchaseTable.vue?vue&type=template&id=e231628c&"
import script from "./OtherPurchaseTable.vue?vue&type=script&lang=js&"
export * from "./OtherPurchaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports